module.exports = __webpack_public_path__ + "static/media/enedis.1b95be76.png";